"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HouseholdTs1CTACard = HouseholdTs1CTACard;
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
require("./household-member-card.scss");
const constants_1 = require("core/constants");
const React = __importStar(require("react"));
function HouseholdTs1CTACard() {
    // Keep the domain of the URL, change the pathname to /players
    const ctaUrl = new URL(constants_1.IDENTITY_URL);
    ctaUrl.pathname = '/players';
    return (React.createElement("div", { "data-testid": "go-to-ts1-household-card", className: "Grid-cell u-xs-size1of2 u-sm-size1of3 u-padBottomMd" },
        React.createElement("div", { className: "sui-p-3 sui-bg-white sui-border-solid sui-border-neutral-border sui-border sui-flex sui-flex-col sui-text-center" },
            React.createElement("h3", { className: "sui-font-semibold sui-body" }, "Looking for your other players?"),
            React.createElement("p", { className: "sui-caption" }, "You can access your other TeamSnap ONE players that aren't shown here in your TeamSnap ONE dashboard."),
            React.createElement(teamsnap_ui_1.Button, { color: "primary u-sizeFull", onClick: () => window.open(ctaUrl.toString(), '_blank', 'noopener,noreferrer') }, "Go to TeamSnap ONE"))));
}
